import React, { useRef, useEffect } from 'react';
import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import Sidebar from './Sidebar';
import MobileNav from './MobileNav';
import GradualBlur from './GradualBlur';

const BOTTOM_NAV_HEIGHT = 56;

const pageTransition = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -4 },
  transition: { duration: 0.18, ease: [0.16, 1, 0.3, 1] },
};

const AppLayout = ({ children }) => {
  const location = useLocation();
  const prevPath = useRef(location.pathname);

  useEffect(() => {
    if (prevPath.current !== location.pathname) {
      prevPath.current = location.pathname;
      const main = document.querySelector('main');
      main?.focus({ preventScroll: true });
    }
  }, [location.pathname]);

  if (location.pathname === '/login' || location.pathname === '/child-login') {
    return <>{children}</>;
  }

  return (
    <>
      <GradualBlur
        position="bottom" strength={1} height="1px" opacity={0}
        style={{ position: 'fixed', pointerEvents: 'none', zIndex: -1 }}
      />
      {/* Mobile layout - CSS hidden on desktop */}
      <Box sx={{
        display: { xs: 'flex', md: 'none' },
        flexDirection: 'column',
        minHeight: '100dvh',
        bgcolor: 'background.default',
      }}>
        <MobileNav />
        <Box component="main" tabIndex={-1} sx={{
          flex: 1,
          pb: `calc(${BOTTOM_NAV_HEIGHT}px + env(safe-area-inset-bottom, 0px))`,
          outline: 'none',
        }}>
          <AnimatePresence>
            <motion.div key={location.pathname} {...pageTransition}>
              {children}
            </motion.div>
          </AnimatePresence>
        </Box>
      </Box>

      {/* Desktop layout - CSS hidden on mobile */}
      <Box sx={{
        display: { xs: 'none', md: 'flex' },
        minHeight: '100dvh',
        bgcolor: 'background.default',
      }}>
        <Sidebar />
        <Box component="main" tabIndex={-1} sx={{ flex: 1, minWidth: 0, bgcolor: 'background.default', outline: 'none' }}>
          <AnimatePresence>
            <motion.div key={location.pathname} {...pageTransition}>
              {children}
            </motion.div>
          </AnimatePresence>
        </Box>
      </Box>
    </>
  );
};

export default AppLayout;
